export default "__VITE_ASSET__dbb4e358__"